import styled from "styled-components/macro";

const SIZE_MAP = {
  S: 14,
  M: 16
};

const COLOR_MAP = {
  neutral: "#1F1F1F",
  brand: "#6049F5"
};

export const CheckboxWrapper = styled.label`
  display: flex;
  align-items: ${({ description }) => (description ? "flex-start" : "center")};
  gap: 4px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  user-select: none;
  width: fit-content;
  height: ${({ description }) => !description && "20px"};
`;

export const HiddenCheckbox = styled.input`
  display: none;
`;

export const StyledCheckbox = styled.span`
  width: 12px;
  height: 12px;
  border-radius: 2px;
  border: 2px solid
    ${({ colorType, checked }) =>
      checked ? COLOR_MAP[colorType] : "var(--Neutral-80)"};
  background-color: ${({ checked, colorType }) =>
    checked ? COLOR_MAP[colorType] : "transparent"};

  margin: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CheckIcon = styled.svg`
  width: ${({ size }) => (size === "S" ? 7 : 8)}px;
  height: ${({ size }) => (size === "S" ? 9 : 9)}px;
  display: block;
`;

export const Content = styled.div`
  /* flex: 1; */
  width: fit-content;
`;

export const LabelRow = styled.div`
  font-size: ${({ size }) => (size === "S" ? "12px" : "14px")};
  color: ${({ checked }) =>
    checked ? "var(--Neutral-100)" : "var(--Neutral-80)"};
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.014px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const Description = styled.div`
  color: var(--Neutral-80);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.012px;
`;

export const InfoIcon = styled.span`
  width: 12px;
  height: 12px;
`;
